import { render, staticRenderFns } from "./index-fix.vue?vue&type=template&id=6abd5416&scoped=true"
import script from "./index-fix.vue?vue&type=script&lang=js"
export * from "./index-fix.vue?vue&type=script&lang=js"
import style0 from "./index-fix.vue?vue&type=style&index=0&id=6abd5416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd5416",
  null
  
)

export default component.exports